function formatGQLError(err) {
  const errMsg = err?.message
  if (!errMsg) {
    return ""
  }
  return errMsg.replaceAll("GraphQL error: ", "")
}

export default formatGQLError